
import sileo from 'sileo';
import axios from 'source/lib/axios';

const ClientQueryProposal = new sileo.Model('scalema_new', 'client-query-proposal');
const ClientQueryProposalAmazonFormData = new sileo.Model('scalema_new', 'client-query-proposal-amazon-form-data');

const NavigationQuery = new sileo.Model('scalema_new', 'client-queries');
const Clients = new sileo.Model('scalema_new', 'client-owner-queries');
const NavigationNegotiation = new sileo.Model('scalema_new', 'navigation-negotiation');
const DetailedClientQueryResource = new sileo.Model('scalema_new', 'detailed-client-query');
const TPSolutionsResource = new sileo.Model('scalema_new', 'query-solutions');
const OpenClientQueries = new sileo.Model('scalema_new', 'open-client-queries');
const ClientQueryProposals = new sileo.Model('scalema_new', 'tp-client-query-proposals');
const ClientContract = new sileo.Model('scalema_new', 'client-contract');
const WorkforceClientContract = new sileo.Model('scalema_new', 'workforce-client-contract');
const PendingPersonalQueries = new sileo.Model('scalema_new', 'pending_personal_queries');
const SolutionVideoUpload = new sileo.Model('scalema_new', 'upload-proposal-video');
const QueryDetails = new sileo.Model('scalema_new', 'client-query-details');
const ClientQueryDetails = new sileo.Model('scalema_new', 'tp-client-query-details');
const AmazonFormData = new sileo.Model('scalema_new', 'amazon-form-data');

const TPContract = new sileo.Model('scalema_new', 'tp-contract');
const TPContractTemplates = new sileo.Model('scalema_new', 'tp-contract-templates');
const TPContractTemplateContent = new sileo.Model('scalema_new', 'tp-contract-template-content');
const SimpleClientQueryProposal = new sileo.Model('scalema_new', 'simple-client-query-proposal');
const RootTPSidebarQueryCount = new sileo.Model('scalema_new', 'client-query-notification');
const TrustedPartners = new sileo.Model('scalema_new', 'trusted-partner');
const TrustedPartnerApplication = new sileo.Model('scalema_new', 'tp-application');

const MessageThreadStatusUpdateResource = new sileo.Model('scalema_new', 'message-thread-status');
const TPSideBarCount = new sileo.Model('scalema_new', 'tp-side-bar-count');
const TrustedPartnerContractMessageThread = new sileo.Model('scalema_new', 'tp-contract-message-thread');
const TrustedPartnerContractMessage = new sileo.Model('scalema_new', 'tp-contract-message');
const ConversationTemplateMessageBlocks = new sileo.Model('ai', 'conversation-template-message-blocks');
const ConversationTemplate = new sileo.Model('ai', 'conversation-template');
const MessageBlockPresetReset = new sileo.Model('ai', 'messageblock-preset-reset');

const WorkforceAcknowledgment = new sileo.Model('scalema_new', 'workforce-acknowledgment');

const ClientWorkforces = new sileo.Model('scalema_new', 'client-workforces');
const ClientWorkforcePermissions = new sileo.Model('scalema_new', 'client-workforce-permissions');
const ClientWorkforceEmployees = new sileo.Model('scalema_new', 'client-workforce-employees');
const ClientInvoiceItem = new sileo.Model('scalema_new', 'client-invoice-item');

const ClientQueryDashboard = new sileo.Model('scalema_new', 'client-queries-dashboard');
const DashboardClients = new sileo.Model('scalema_new', 'client-info');
const ClientInfoMarketingClient = new sileo.Model('scalema_new', 'client-info-email-marketing');
const QueryPrososalNegotiations = new sileo.Model('scalema_new', 'query-proposal-negotiations');

const SimpleConversationTemplatePresets = new sileo.Model('ai', 'simple-conversation-template-presets');
const ConversationTemplatePreset = new sileo.Model('ai', 'conversation-template-preset');
const DuplicateConversationTemplatePreset = new sileo.Model('ai', 'duplicate-conversation-template-preset');

const NegotiationMessageThread = new sileo.Model('scalema_new', 'negotiation-sidebar-message-thread');
const ScalemaEmailConversion = new sileo.Model('scalema_new', 'email-conversion');

const ClientInvoice = new sileo.Model('scalema_new', 'client-invoice');
const InvoiceEmployeePayrolls = new sileo.Model('scalema_new', 'invoice-employee-payroll');
const BillerInformation = new sileo.Model('scalema_new', 'biller-information');
const ClientInformation = new sileo.Model('scalema_new', 'client-information');

const state = {
    navQueries: [],
    navContractTemplates: [],
    navClientNegotiations: [],
    navTPNegotiations: [],
    navTPSidebarCount: {},
    tpRootSideBarCount: 0,
    contractConfigOtherFields: null,
    selectedClients: [],
    queryProposalsExist: null,
    errorsOnJobPricingRates: false,
    navNegotiationsCount: null,
    selectedQueryDate: '',
    selectedQueryStartDate: '',
    selectedQueryEndDate: '',
    tpCount: 0,
};

const mutations = {
    setNavQueries(state, payload) {
        state.navQueries = payload;
    },

    setContractTemplates(state, payload) {
        state.navContractTemplates = payload;
    },

    setJobPricingCurrencyErrors(state, payload) {
        state.errorsOnJobPricingRates = payload;
    },

    setQueryProposalsExistStatus(state,payload) {
        state.queryProposalsExist = payload;
    },

    setNavClientNegotiations(state, payload) {
        state.navClientNegotiations.concat(payload);
    },

    setNavTPNegotiations(state, payload) {
        state.navTPNegotiations.concat(payload);
    },

    setNavNegotiationsCount(state, payload) {
        state.navNegotiationsCount = payload;
    },

    decrementProposedSolutions(state, payload) {
        let navQuery = state.navQueries[payload.index];
        navQuery.proposed_solutions_count--;
    },

    decrementNegotiatingSolutions(state, payload) {
        let navQuery = state.navQueries[payload.index];
        navQuery.negotiating_solutions_count--;
    },

    incrementNegotiatingSolutions(state, payload) {
        let navQuery = state.navQueries[payload.index];
        navQuery.negotiating_solutions_count++;
    },

    incrementSelectedSolutions(state, payload) {
        let navQuery = state.navQueries[payload.index];
        navQuery.selected_solutions_count++;
    },

    incrementRejectedSolutions(state, payload) {
        let navQuery = state.navQueries[payload.index];
        navQuery.rejected_solutions_count++;
    },

    setNavTPSidebarCount(state, payload) {
        state.navTPSidebarCount = payload;
    },

    setTpRootSidebarCount(state, payload) {
        state.tpRootSideBarCount = payload;
    },

    setContractConfigOtherFields(state, payload) {
        state.contractConfigOtherFields = payload;
    },

    setSelectedClients(state, data) {
        state.selectedClients = data;
    },

    setSelectedQueryDate(state, data) {
        state.selectedQueryDate = data;
    },
    setSelectedQueryStartDate(state, data) {
        state.selectedQueryStartDate = data;
    },
    setSelectedQueryEndDate(state, data) {
        state.selectedQueryEndDate = data;
    },
    setTpCount(state,data) {
        state.tpCount = data;
    }
};

const actions = {
    getClientQueryProposal: function(context, pk) {
        return ClientQueryProposal.objects.get(pk);
    },

    fetchClientQueryProposal(context, filters) {
        return ClientQueryProposal.objects.filter(filters);
    },

    updateClientQueryProposal: function(context, data) {
        const form = new FormData();
        let pk = data.pk;
        let dataKeys = Object.keys(data);

        dataKeys.forEach(key => {
            form.append(key, data[key]);
        });

        return ClientQueryProposal.objects.update({ 'pk': pk }, form);
    },

    fetchNavigationQueries(context, filters) {
        return NavigationQuery.objects.filter(filters).then(data => {
            context.commit('setNavQueries', data);
            return data;
        });
    },

    fetchNavigationNegotiation(context, filters) {
        return NavigationNegotiation.objects.filter(filters).then(data => {
            if (filters.type === 'trusted-partner') {
                context.commit('setNavTPNegotiations', data);
            } else {
                data = data.map(item => ({ ...item, query_id: filters.query_id }));
                context.commit('setNavClientNegotiations', data);
            }
            return data;
        });
    },

    movePendingToNegotiatingQuery(context, payload) {
        context.commit('decrementProposedSolutions', payload);
        context.commit('incrementNegotiatingSolutions', payload);
    },

    moveNegotiatingToAcceptedQuery(context, payload) {
        context.commit('decrementNegotiatingSolutions', payload);
        context.commit('incrementSelectedSolutions', payload);
    },

    movePendingToAcceptedQuery(context, payload) {
        context.commit('decrementProposedSolutions', payload);
        context.commit('incrementSelectedSolutions', payload);
    },

    fetchClientQuery(context, filters) {
        return DetailedClientQueryResource.objects.filter(filters);
    },

    fetchQuerySolutions(context, filters) {
        return TPSolutionsResource.objects.filter(filters);
    },

    getQuerySolution(context, queryId) {
        return TPSolutionsResource.objects.get(queryId);
    },

    updateQuerySolutionStatus(context, { pk, data }) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return TPSolutionsResource.objects.update({ 'pk': pk }, form);
    },

    getClientContract(context, pk) {
        return ClientContract.objects.get(pk);
    },

    fetchPreviousTpContracts(context, filters) {
        return TPContract.objects.filter(filters);
    },

    getClientContracts(context, pk) {
        return ClientContract.objects.filter({ 'pk': pk });
    },

    submitClientContract(context, data) {
        return new Promise((res) => {
            data.signature.save(async(blob) => {
                const formData = new FormData();
                formData.append('pk', data.pk);
                formData.append('location', data.location);
                formData.append('signature', blob);
                let response = await ClientContract.objects.update({ pk: data.pk }, formData);
                res(response);
            });
        });
    },

    fetchWorkforceContract(context, filters) {
        return WorkforceClientContract.objects.filter(filters);
    },

    signTPContract(context, data) {
        return new Promise((res) => {
            data.signature.save(async(blob) => {
                const formData = new FormData();
                formData.append('pk', data.pk);
                formData.append('location', data.location);
                formData.append('signature', blob);
                let response = await TPContract.objects.update({ pk: data.pk }, formData);
                res(response);
            });
        });
    },

    fetchPendingPersonalQueries(context, filters) {
        return PendingPersonalQueries.objects.filter(filters);
    },

    fetchOpenClientQueries(context, filters) {
        return OpenClientQueries.objects.filter(filters);
    },

    fetchClients(context, filters) {
        return Clients.objects.filter(filters);
    },

    fetchClientQueryProposals(context, filters) {
        return ClientQueryProposals.objects.filter(filters);
    },

    async uploadProposalVideoAWS({ commit }, payload) {
        const { file } = payload;
        return await AmazonFormData.objects.filter()
            .then(response => {
                const { amazon } = response;
                const formData = new FormData();

                formData.append('key', amazon.key);
                formData.append('acl', amazon.acl);
                formData.append('Content-Type', amazon.content_type);
                formData.append('Policy', amazon.policy);
                formData.append('X-Amz-Signature', amazon.signature);
                formData.append('x-amz-server-side-encryption', amazon.server_side_encryption);
                formData.append('X-Amz-Algorithm', amazon.algorithm);
                formData.append('X-Amz-Date', amazon.date);
                formData.append('X-Amz-Credential', amazon.credential);
                if (amazon.success_action_redirect) {
                    formData.append('success_action_redirect', amazon.success_action_redirect);
                }
                for (let key in amazon.metas) {
                    formData.append('x-amz-meta-' + key, amazon.metas[key]);
                }
                formData.append('file', file);

                return new Promise((resolve, reject) => {
                    const request = new XMLHttpRequest();
                    request.addEventListener('readystatechange', async (e) => {
                        if (request.readyState === request.DONE && request.status >= 200 && request.status < 300) {
                            const payload = {
                                video_uuid: amazon.key.split('/').pop()
                            };
                            resolve(payload);
                        }
                    });

                    request.open('POST', amazon.action, true);
                    request.send(formData);
                });
        });
    },

    async fetchQueryProposalAmazonFormData(context) {
        let data = await ClientQueryProposalAmazonFormData.objects.filter();
        return data.amazon;
    },

    createProposal(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return ClientQueryProposal.objects.create(form);
    },

    uploadSolutionVideo(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return SolutionVideoUpload.objects.create(form);
    },

    getQueryDetails(context, pk) {
        return QueryDetails.objects.get(pk);
    },

    getClientQueryDetails(context, pk) {
        return ClientQueryDetails.objects.get(pk);
    },

    updateClientQueryDetails(context, data) {
        return ClientQueryDetails.objects.update({ pk: data.pk }, data);
    },

    fetchTPContractTemplates(context, filters) {
        return TPContractTemplates.objects.filter(filters).then(data => {
            context.commit('setContractTemplates', data);
            return data;
        });
    },

    updateContractTemplate(context, data) {
        return TPContractTemplates.objects.update({ pk: data.template_id }, data);
    },

    getTPContractTemplateContent(context, pk) {
        return TPContractTemplateContent.objects.get(pk);
    },

    getSimpleClientQueryProposal(context, pk) {
        return SimpleClientQueryProposal.objects.get(pk);
    },

    createTPContract(context, data) {
        let form = new FormData();

        for (let [key, value] of Object.entries(data)) {
            form.append(key, value);
        }

        return TPContract.objects.create(form);
    },

    updateTPContract(context, data) {
        let form = new FormData();

        for (let [key, value] of Object.entries(data)) {
            form.append(key, value);
        }

        return ClientContract.objects.update({ pk: data.pk }, form);
    },

    getTPContract(context, pk) {
        return TPContract.objects.get(pk);
    },

    getTPSideBarCount(context, pk=1) {
        return TPSideBarCount.objects.get(pk).then(data => {
            context.commit('setNavTPSidebarCount', data);
            return data;
        });
    },

    fetchClientQueryCount(context, filters) {
        return RootTPSidebarQueryCount.objects.filter(filters).then(data => {
            context.commit('setTpRootSidebarCount', data.unseen_count);
            return data;
        });
    },

    markClientQueriesAsRead(context, data) {
        return RootTPSidebarQueryCount.objects.update({}, data);
    },

    getAndSetOtherContractConfigFields(context, data) {
        return context.commit('setContractConfigOtherFields', data);
    },

    updateMessageThread(context, data) {
        const form = new FormData();
        form.append('seen', data.seen);
        form.append('read', data.read);
        form.append('latest_message_read', data.lastMessageRead);
        return MessageThreadStatusUpdateResource.objects.update({ pk: data.pk }, form);
    },

    getMessageThread(context, filters) {
		return TrustedPartnerContractMessageThread.objects.filter(filters);
	},

    createThread(context, data) {
        return TrustedPartnerContractMessageThread.objects.create(data);
    },

    createMessage(context, data) {
		const form = new FormData();

		for (let field in data) {
			form.append(field, data[field]);
		}

		return TrustedPartnerContractMessage.objects.create(form);
	},

    getMessage(context, pk) {
        return TrustedPartnerContractMessage.objects.get(pk);
    },

    fetchMessages(context, filters) {
		return TrustedPartnerContractMessage.objects.filter(filters);
	},

    fetchTrustedPartners(context, filters) {
        return TrustedPartners.objects.filter(filters);
    },

    fetchTrustedPartnersCount(context, filters) {
        TrustedPartnerApplication.objects.filter(filters).then(data=>{
            context.commit('setTpCount', data.application_count);
        });
    },

    fetchTPApplications(context, filters) {
        return TrustedPartnerApplication.objects.filter(filters);
    },

    fetchWorkforceAcknowledgment(context, userPk) {
        return WorkforceAcknowledgment.objects.filter({ user__pk: userPk });
    },

    acknowledgeWorkforce(context, pk) {
        return WorkforceAcknowledgment.objects.update({ pk: pk });
    },

    fetchMessageBlocksTemplate(context, filters) {
        return ConversationTemplateMessageBlocks.objects.filter(filters);
    },

    fetchConversationTemplates(context, filters) {
        return ConversationTemplate.objects.filter(filters);
    },

    updateConversationTemplate(context, data) {
        return ConversationTemplate.objects.update({ pk: data.template_id }, data);
    },

    createMessageBlocksTemplate(context, data) {
        const form = new FormData();

		for (let field in data) {
			form.append(field, data[field]);
		}

        return ConversationTemplateMessageBlocks.objects.create(form);
    },

    updateMessageBlocksTemplate(context, data) {
        const form = new FormData();

		for (let field in data) {
			form.append(field, data[field]);
		}

        return ConversationTemplateMessageBlocks.objects.update({ pk: data.pk }, form);
    },

    resetMessageBlocksPreset(context, data) {
        return MessageBlockPresetReset.objects.update(data, { 'id': data.template_preset_id });
    },

    fetchClientWorkforces(context, filters) {
        return ClientWorkforces.objects.filter(filters).then(data => {
            return data;
        });
    },

    fetchClientWorkforcePermissions(context, filters) {
        return ClientWorkforcePermissions.objects.filter(filters).then(data => {
            return data;
        });
    },

    getClientWorkforces(context, pk) {
        return ClientWorkforces.objects.get(pk);
    },

    updateClientWorkforcePermissions(context, data) {
        const form = new FormData();
        form.append('workforce_id', data.workforce_id);
        form.append('permissions', JSON.stringify(data.permissions));
        return ClientWorkforcePermissions.objects.update({}, form);
    },

    fetchWorkforceEmployees(context, filters) {
        return ClientWorkforceEmployees.objects.filter(filters);
    },

    updateWorkforceEmployeePermissions(context, data) {
        const form = new FormData();
        form.append('employment_id', data.employment_pk);
        form.append('workforce_id', data.workforce_id);
        form.append('permission', data.permission);
        return ClientWorkforceEmployees.objects.update({}, form);
    },

    fetchClientInvoiceItem(context, filters) {
        return ClientInvoiceItem.objects.filter(filters);
    },

    createClientInvoiceItem(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return ClientInvoiceItem.objects.create(form);
    },

    fetchClientQueryDashboard(context, filters) {
        return ClientQueryDashboard.objects.filter(filters);
    },

    fetchDashboardClients(context, filters) {
        return DashboardClients.objects.filter(filters);
    },

    fetchEmailMarketingClients(context, filters) {
        return ClientInfoMarketingClient.objects.filter(filters);
    },

    fetchQueryProposalNegotiations(context, filters) {
        return QueryPrososalNegotiations.objects.filter(filters);
    },

    updateTrustedPartnerStatus(context, data) {
        const form = new FormData();
        form.append('removed', data.removed);

        return TrustedPartners.objects.update({ 'pk': data.trusted_partner.pk }, form);
    },

    fetchSimpleConversationTemplatesPresets(context, filters) {
        return SimpleConversationTemplatePresets.objects.filter(filters);
    },

    fetchPresetMessageBlocks(context, pk) {
        return ConversationTemplatePreset.objects.get(pk);
    },

    duplicateConversationTemplatePreset(context, filters) {
        return DuplicateConversationTemplatePreset.objects.create(filters);
    },

    createConversationTemplatePreset(context, data) {
        return ConversationTemplatePreset.objects.create(data);
    },

    fetchMessageBlocksPreset(context, filters) {
        return ConversationTemplatePreset.objects.filter(filters);
    },

    fetchNavNegotiationsCount(context, filters) {
        NegotiationMessageThread.objects.filter(filters).then(data => {
            context.commit('setNavNegotiationsCount', data.total_count);
        });
    },

    createResumeAnalysis(context, payload) {
        const form = new FormData();
        Object.keys(payload).forEach((key) => {
          form.append(key, payload[key]);
        });
        return axios.post('ai/resume-analysis', form);
    },

    fetchResumeAnalysis(context, params) {
        return axios.get('ai/resume-analysis', { params: params });
    },

    inviteTrustedPartner(context, data) {
        const form = new FormData();
        for (let field in data) {
			form.append(field, data[field]);
		}
        return TrustedPartnerApplication.objects.create(form);
    },

    updateTrustedPartnerApplication(context, data) {
        const form = new FormData();
        form.append('reason', data.reason);
        form.append('status', data.status);
        form.append('email', data.email);
        form.append('company_id', data.company_id);
        return TrustedPartnerApplication.objects.update({ pk: data.pk }, form);
    },

    createClientQueryFromCTAs(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return ScalemaEmailConversion.objects.create(form);
    },

    // Client Invoice Resources
    fetchClientInvoices(context, filters) {
        return ClientInvoice.objects.filter(filters);
    },

    updateClientInvoice(context, data) {
        const form = new FormData();
        let pk = data.pk;
        let dataKeys = Object.keys(data);

        dataKeys.forEach(key => {
            form.append(key, data[key]);
        });
        return ClientInvoice.objects.update({ 'pk': pk }, form);
    },

    getClientInvoice(context, pk) {
        return ClientInvoice.objects.get(pk);
    },

    fetchInvoiceEmployeePayrolls(context, filters) {
        return InvoiceEmployeePayrolls.objects.filter(filters);
    },

    createBillerInformation(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return BillerInformation.objects.create(form);
    },

    createClientInformation(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return ClientInformation.objects.create(form);
    },

    updateBillerInformation(context, data) {
        const form = new FormData();
        let pk = data.pk;
        let dataKeys = Object.keys(data);

        dataKeys.forEach(key => {
            form.append(key, data[key]);
        });
        return BillerInformation.objects.update({ 'pk': pk }, form);
    },

    updateClientInformation(context, data) {
        const form = new FormData();
        let pk = data.pk;
        let dataKeys = Object.keys(data);

        dataKeys.forEach(key => {
            form.append(key, data[key]);
        });
        return ClientInformation.objects.update({ 'pk': pk }, form);
    },

    fetchBillerInformation(context, filters) {
        return BillerInformation.objects.filter(filters);
    },

    fetchClientInformation(context, filters) {
        return ClientInformation.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
